import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'

const firebaseConfig = {
	apiKey: 'AIzaSyD5BkAn856iewa8BNa0dyyqavtnLoPLJoM',
	authDomain: 'livecart-24e87.firebaseapp.com',
	databaseURL: 'https://livecart-24e87-default-rtdb.firebaseio.com',
	projectId: 'livecart-24e87',
	storageBucket: 'livecart-24e87.appspot.com',
	messagingSenderId: '874012932040',
	appId: '1:874012932040:web:1b89cf041157313c5ef2fd',
	measurementId: 'G-BQ4Q9FDFM8',
}
const app = initializeApp(firebaseConfig)

export async function init(navigator, callback) {
	// add navigator to init function and then paste the following line in
	const sw = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
	const messaging = getMessaging(app)

	if (messaging) {
		getToken(messaging, {
			serviceWorkerRegistration: sw,
			vapidKey:
				'BJM5kQS3RRqjO_KU2MNswwe9HS_KfaL8C-apzVkOeQ8HTXup51vnsONT4u7qwdWsN0Zbr3_UxrAzfhhyIC61OLI',
		})
			.then(currentToken => {
				if (currentToken) {
					callback(currentToken)
					if (
						!localStorage.getItem('fb_token') ||
						localStorage.getItem('fb_token') !== currentToken
					) {
						localStorage.setItem('fb_token', currentToken)
						/* TBD:  call the api to register this device for a specific user using this token */
					}
				} else {
					console.log('fb_token invalid')
				}
			})
			.catch(err => {
				console.log('notif:' + err)
			})
	} else {
		console.log('notifs invalid')
	}
}
